<!-- @format -->

<div class="list-container">
  <dl
    [class.fill-by-column]="fillByColumn === true"
    [class.fill-by-row]="fillByColumn === false"
    [class.one-column]="columnCount === 1"
    role="list">
    @for (template of childTemplates; track template) {
      <div class="form-group-mimic" role="listitem">
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      </div>
    }
  </dl>
</div>
